const initialState = {
	isLoading: 0
};

export default (state = initialState, action) => {
	switch (action.type) {
		case "COLOR_STATUSES_IS_LOADING":
			return {
				...state,
				isLoading: 1
			};
		case "COLOR_STATUSES_HAS_ERROR":
			return {
				...state,
				isLoading: 0,
				error: action.error
			};
		case "COLOR_STATUSES_SUCCESS":
			return {
				...state,
				colorStatuses: action.data.colorStatuses,
				isLoading: 0
			};

		default:
			return state;
	}
};



// WEBPACK FOOTER //
// ./src/store/reducers/colorStatuses.js